import React from 'react';
import {NavLink} from 'react-router-dom';
import {STUDIO_IDS} from '../hooks/useConsultationActionCounts';
import './CancellationCenter.css';
import './ConfirmationCenter.css';
export function badgeTarget(kind,studioId,counts){
 if(kind==='confirm')return `/consultations?confirmations=1${studioId?`&locationId=${studioId}`:''}`;
 const id=studioId || (kind==='cancel'?null:STUDIO_IDS.find(key=>(counts?.[key]?.[kind==='new'?'newCount':'changeCount'] || 0)>0));
 return kind==='cancel'?`/consultations?cancellations=1${id?`&locationId=${id}`:''}`:`/consultations?tasks=1&kind=${kind}${id?`&locationId=${id}`:''}`;
}
export default function ConsultationActionBadges({count,studioId,counts,onClick}){
 return <span className="pi-action-badges">{[
  {key:'new',amount:count.newCount,label:'Neue Anfragen'},
  {key:'change',amount:count.changeCount,label:'Terminwünsche'},
  {key:'cancel',amount:count.cancelCount,label:'Ungesehene Stornierungen'},
  {key:'confirm',amount:count.confirmCount,label:'Ungesehene Bestätigungen'},
 ].filter(item=>item.amount>0).map(item=><NavLink key={item.key} className={`pi-action-badge pi-action-${item.key}`} to={badgeTarget(item.key,studioId,counts)} onClick={onClick} aria-label={`${item.amount} ${item.label}`} title={`${item.amount} ${item.label}`}>{item.amount>99?'99+':item.amount}</NavLink>)}</span>;
}
// prime-ink-confirmation-notifications-v1
